module.exports = __webpack_public_path__ + "static/media/satellite.e4aaf0ca.svg";